<template>
  <div>
    <div class="all">
      <img
        src="../assets/img/ICON_close_mob.svg"
        alt=""
        @click="re"
        class="close-img"
      />
      <div class="time">
        <div class="day">{{ handlerTitleTime($route.query.newsTime) }}</div>
        <div class="time-date">
          <div class="yearMonth">
            {{ handlerYears($route.query.newsTime) }}
          </div>
          <div class="gang"></div>
        </div>
      </div>
      <h3>{{ title }}</h3>
      <div ref="contentContainer" v-if="content">
        <div v-html="content" v-custom-image></div>
      </div>
    </div>

    <div class="bm">
      <span>
        版权所有©深圳昌恩智能股份有限公司　
        <a style="color: #fff" target="_blank" href="http://beian.miit.gov.cn"
          >粤ICP备17113788号</a
        ></span
      >
    </div>
  </div>
</template>

<script>
import { handlerTitleTime, handlerYears } from '../utils/handlerTime'
export default {
  name: 'newdetailed',
  data () {
    return {
      handlerTitleTime,
      handlerYears,
      resourId: this.$route.query.id,
      day: '',
      year: '',
      title: '',
      content: '',
      previousRoute: ''
    }
  },
  created () {
    this.selectById()
  },
  mounted () {
    const previousRoute = this.$route.params.previousRoute
    this.previousRoute = previousRoute
    console.log(this.previousRoute)
    // console.log("pageNum", this.$route.query.pageNum);
  },

  methods: {
    re () {
      const query = this.$route.query.pageNum
      this.$router.push({ path: this.previousRoute, query: { query } })
    },
    selectById () {
      console.log('id', this.$route.query.id)
      this.request
        .get(`/edit/${this.$route.query.id}`, {
          // 问题：   如何判断输入了那些条件只传查询条件 空的不传   ??????
        })
        .then(res => {
          console.log('detail', res.data)
          // this.day = res.data.data.createTime.slice(8, 10);
          // this.year = res.data.data.createTime.slice(0, 7);
          this.title = res.data.data.title
          this.content = res.data.data.content
        })
    }
  }
}
</script>

<style scoped>
.all /deep/ img {
  /* Add your custom styles here */
  width: 100%; /* Example: Set the width to 100% */
  /* ... */
}
.all /deep/ h3 {
  margin-bottom: 4vw;
  font-size: 4.267vw;
  font-weight: bold;
  color: #000000;
  line-height: 6vw;
}
.all /deep/ p {
  font-size: 3.2vw;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.6);
  line-height: 5.333vw;
  letter-spacing: 1px;
}
.all {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  padding: 0 4vw;
  margin-top: 4vw;
  margin-bottom: 10.6667vw;
}
.all h3 {
  text-align: center;
}
.all .close-img {
  position: absolute;
  right: 4.2667vw;
  width: 4.2667vw;
  height: 4.2667vw;
}
.time {
  display: flex;
  align-items: flex-end;
  margin-top: 8.533vw;
  margin-bottom: 5.333vw;
}
.time .day {
  margin-right: 1.6vw;
  font-size: 4.8vw;
  font-weight: bold;
  color: #1d1d1d;
  letter-spacing: 2px;
  font-family: DINAlternate-Bold, DINAlternate;
}
.time .time-date {
  font-size: 2.133vw;
  color: rgba(29, 29, 29, 0.22);
  font-weight: bold;
}

.gang {
  /* float:left; */
  margin-top: 3px;
  width: 2.4vw;
  height: 0.2667vw;
  background-color: #ffa200;
}
.bm {
  position: fixed;
  bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/newdetailed.vue